import type { RadioGroupProps, TextProps } from 'uikit';
import { cnMixSpace, Text, RadioGroup } from 'uikit';

import type React from 'react';
import { useCallback } from 'react';
import type { Control } from 'react-hook-form';
import { useController } from 'react-hook-form';

interface IControlledRadioProps extends Omit<RadioGroupProps, 'onChange'> {
    name: string;
    control: Control<any>;
    defaultValueRadio?: RadioGroupProps['value'];
    textLabel?: string | React.ReactNode;
    textSize?: TextProps['size'];
    textView?: TextProps['view'];
    className?: string;
}

export const ControlledRadio = ({
    name,
    control,
    items,
    defaultValueRadio,
    textLabel,
    textSize,
    textView,
    className,
    ...radioGroupProps
}: IControlledRadioProps) => {
    const {
        field: { value, onChange },
    } = useController({
        name,
        control,
        defaultValue: defaultValueRadio || items[0],
    });

    const handleChangeType = useCallback(
        (evt: { e: React.ChangeEvent<HTMLInputElement>; value: RadioGroupProps['value'] }) => {
            onChange(evt.value);
        },
        [onChange],
    );

    return (
        <div className={className} style={{ display: 'flex' }}>
            {textLabel && (
                <Text size={textSize} view={textView} style={{ maxWidth: '340px' }} className={cnMixSpace({ mR: 'm' })}>
                    {textLabel}
                </Text>
            )}
            <RadioGroup items={items} value={value} onChange={handleChangeType} {...radioGroupProps} />
        </div>
    );
};

ControlledRadio.displayName = 'ControlledRadio';
